<template>
  <div class="pass-legend-list">
    <div class="pass-legend-item">
      <span class="pass-legend-section" style="background:#67c23a"></span>
      <span class="pass-legend-label">满足</span>
    </div>

    <div class="pass-legend-item unpass">
      <span class="pass-legend-section" style="background:#f56c6c"></span>
      <span class="pass-legend-label">未满足</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PassLegend'
}
</script>

<style lang="scss">
.pass-legend-list {
  font-size: 14px;
  display: flex;
  align-items: center;

  .pass-legend-item {
    display: grid;
    grid-template-columns: 0.65em max-content;
    grid-gap: 5px;
    align-items: center;

    &.unpass {
      .pass-legend-section {
        background-color: #f56c6c;
      }
    }

    .pass-legend-section {
      padding-top: 100%;
      border-radius: 50%;
      background-color: #67c23a;
    }

    .pass-legend-label {
      color: #606266;
      white-space: nowrap;
    }

    & + .pass-legend-item  {
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Legend/PassLegend.vue